if (!window.customElements.get("component-recently-products")) {
class RecentlyViewedProducts  extends HTMLElement {
    constructor() {
        super(...arguments);
        this.sectionID = 'section-recently-viewed';
    }

    connectedCallback() {
        this.defineElements();
        this.removeCurrentItem();
        this.loadProducts();
    }

    defineElements() {
        this.items = new Set(JSON.parse(localStorage.getItem("recently-viewed-products") || "[]"));
        this.section = this.closest('.shopify-section');
        this.tabContent = this.section.querySelector('[data-js-recently-tab-content]');
        this.tabHeaeder = this.section.querySelector('[data-js-recently-tab-header]');
    }

    removeCurrentItem() {
        if (this.hasAttribute("exclude-id")) {
            this.items.delete(
                parseInt(this.getAttribute("exclude-id"))
            );
        }
    }

    createSearchQuery() {
        return Array.from(this.items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
    }

    createRequestUrl() {
        return `${Shopify.routes.root}search?type=product&q=${this.createSearchQuery()}&section_id=${this.sectionID}`
    }


   async loadProducts() {
        if (this.items.size) {
           const response = await fetch(this.createRequestUrl(), { priority: "low" });
           const content = new DOMParser().parseFromString(await response.text(), "text/html");
           this.renderContent(content);
        }
        else {
            if (this.tabContent) this.tabContent.remove();
            if (this.tabHeaeder) this.tabHeaeder.remove();
        }

    }

    renderContent(content) {
        const component = content.querySelector('component-recently-products');
        this.innerHTML = component.innerHTML;
        this.initSlider();
        window?._swat?.initializeActionButtons('component-recently-products')
    }

    initSlider() {
        this.buttonPrev = this.querySelector('.custom-prev-button');
        this.buttonNext = this.querySelector('.custom-next-button');
        this.slider = this.querySelector('swiper-container');

        const swiperParams = {
            slidesPerView: "auto",
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                990: {
                    slidesPerView: 4.22,
                },
                1600: {
                    slidesPerView: 5,
                },
            },
            navigation: {
                nextEl: this.buttonNext,
                prevEl: this.buttonPrev
            },
            on: {
                init() {
                }
            },
        };

        Object.assign(this.slider, swiperParams);

        this.slider.initialize();
    }

}

    window.customElements.define("component-recently-products", RecentlyViewedProducts);
}

if (!window.customElements.get("component-purchased-slider")) {
class componentPurchasedSlider  extends HTMLElement {

    constructor() {
        super();

        this.selectors = {
            swiper: "swiper-container",
            prevEl: ".custom-prev-button",
            nextEl: ".custom-next-button"
        }

        this.slider = this.querySelector(this.selectors.swiper);
        this.buttonPrev = this.querySelector(this.selectors.prevEl);
        this.buttonNext = this.querySelector(this.selectors.nextEl);
        this.initSlider();
        this.addListeners();
    }

    initSlider() {
        const swiperParams = {
            slidesPerView: "auto",
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                990: {
                    slidesPerView: 4.22,
                },
                1600: {
                    slidesPerView: 5,
                },
            },
            navigation: {
                nextEl: this.buttonNext,
                prevEl: this.buttonPrev
            },
            on: {
                init() {
                }
            },
        };

        Object.assign(this.slider, swiperParams);

        this.slider.initialize();

    }

    addListeners() {
        document.addEventListener('shopify:section:reorder', () => this.initSlider());
        document.addEventListener('shopify:section:load',() => this.initSlider());
    }

}

    window.customElements.define("component-purchased-slider", componentPurchasedSlider);
}
